import React from "react";
import "./LiveCardVideo.css";
import posterImg from "../image/liveCard.png";

import { MdKeyboardArrowRight } from "react-icons/md";
import sampleVideo from '../image/temp.mp4';
import { FaRegHeart } from "react-icons/fa";
import save from '../image/save.svg';
import share from '../image/share.svg';
import like from '../image/like.svg';


const LiveCard = ({ data }) => {

  const url = "https://partywitty.com/master/assets/uploads/";



  return (
    <div className="v-card">
      {/* Header */}
      <div className="v-card-header">
        <img
          className="v-profile-img"
          src="https://i.pravatar.cc/40"
          alt="Club"
        />
        <div className="v-header-text">
          <h4>{data?.clubName}</h4>
          <p>{data?.distance} Km</p>
        </div>
        <div className="v-dots">•••</div>
      </div>


      {/* Offer strip */}
      <div className="v-offer-strip">
        Add On up to 50% Extra on Food & Beverages
      </div>
      {/* Banner */}
      <div className="v-card-banner">
        <video
          src={sampleVideo}
          poster={posterImg}
          autoPlay
          muted
          loop
          playsInline
          className="live-card-video"
        >
          <source src={url + data?.video} type="video/mp4" />
        </video>
        <div className="v-label-banner">{data?.event_date}</div>
          <div className="v-event-details">
          <h3>{data?.name}</h3>
          <p>{data?.clubName}</p>
          <div className="v-event-t-btn">
            <div className="v-event-info">
              <p>📅 {data?.event_date}</p>
              <p>⏰ {data?.event_time}</p>
            </div>
            <button className="v-book-btn">Book Now</button>
          </div>
        </div>
      </div>


      {/* CTA Button */}
      <div className="v-cta-button">Book Now <span className="v-arrow-icon-live"><MdKeyboardArrowRight /></span></div>

      <div className="v-card-icons">
        <div>
          <img src={save} alt="" />
        </div>
        <div className="v-card-icons-right">
          <div>
            <img src={like} alt="" />
          </div>
          <div>
            <img src={share} alt="" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="v-card-footer">
        <p>❤️ Liked by XYZ Club and others</p>
        <div className="v-icons">
          <span>🔗</span>
          <span>🔖</span>
        </div>
      </div>
    </div>
  );
};

export default LiveCard;
